<template>
  <div class="cross-border-section" ref="sectionRef">
    <h1 class="section-title">CROSS-BORDER CARD</h1>
    <div class="cards-container">
      <!-- Standard Card -->
      <div
        class="card-block"
        :class="{ 'animate-in': isVisible }"
        style="--animation-order: 1"
      >
        <div class="card-image">
          <img
            src="@/assets/imgsnew/tow/2-1.svg"
            alt="Standard Cross-Border Card"
          />
        </div>
        <h2 class="card-title">
          STANDARD<br />CROSS-BORDER<br />CONSUMER CARD
        </h2>
        <p class="card-description">
          Indulge in the beauty of cross-border experiences and make everything
          simple, as simple as having tea in your back garden. Enjoy a seamless
          global cross-border experience.
        </p>
      </div>

      <!-- Platinum Card -->
      <div
        class="card-block"
        :class="{ 'animate-in': isVisible }"
        style="--animation-order: 2"
      >
        <div class="card-image">
          <img
            src="@/assets/imgsnew/tow/2-2.svg"
            alt="Platinum Cross-Border Card"
          />
        </div>
        <h2 class="card-title">
          PLATINUM<br />CROSS-BORDER<br />CONSUMER CARD
        </h2>
        <p class="card-description">
          More privileges await, starting from the airport VIP lounges, to the
          ultimate experience of convenient currency exchange, then to the
          all-round global services including translation, local tour guides,
          car rentals, online shopping, as well as a wide array of experiences
          in gourmet food, jewelry, and watches.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const sectionRef = ref(null);
const isVisible = ref(false);
let observer = null;

const observerOptions = {
  threshold: 0.2,
  rootMargin: "0px",
};

const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isVisible.value = true;
    } else {
      isVisible.value = false;
    }
  });
};

onMounted(() => {
  observer = new IntersectionObserver(handleIntersect, observerOptions);
  if (sectionRef.value) {
    observer.observe(sectionRef.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.cross-border-section {
  padding: 80px 0;
  max-width: 1440px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }

  .section-title {
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 60px;

    @media screen and (max-width: 768px) {
      font-size: 28px;
      margin-bottom: 40px;
    }
  }

  .cards-container {
    display: flex;
    justify-content: center;
    gap: 40px;
    padding: 0 80px;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      padding: 0;
      gap: 30px;
    }
  }

  .card-block {
    flex: 1;
    max-width: 600px;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: calc(var(--animation-order) * 0.1s);

    @media screen and (max-width: 768px) {
      max-width: 100%;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }

    .card-image {
      width: 100%;
      margin-bottom: 24px;
      overflow: hidden;

      @media screen and (max-width: 768px) {
        margin-bottom: 16px;
      }

      img {
        width: 100%;
        height: auto;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .card-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 20px;
      line-height: 1.3;
      text-align: center;

      @media screen and (max-width: 768px) {
        font-size: 20px;
        margin-bottom: 16px;
      }
    }

    .card-description {
      font-size: 16px;
      line-height: 1.6;
      color: #666;
      margin: 0;
      text-align: center;

      @media screen and (max-width: 768px) {
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }
}
</style>
